<template>
  <div class="no-access-permission k-body-lg">
    {{ $t('feedback.noPagePer') }}
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style lang="less" scoped>
.no-access-permission {

}
</style>
